import { configureStore } from '@reduxjs/toolkit';
import userSlice from '../reducers/userSlice.js';
import userMiddleware from '../middlewares/userMiddleware.js';
export default configureStore({
    reducer: {
        user: userSlice
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(userMiddleware)
});
